module.exports = __webpack_public_path__ + "img/font2.03b619a6.jpg";